import {
  detectEnvironment,
  Environment,
  isDevelopmentEnv,
  isProductionEnv,
  privateFieldNames,
} from 'shared/config/config'

export { detectEnvironment, privateFieldNames, isProductionEnv, isDevelopmentEnv, Environment }

export function getHeapAppId() {
  if (isProductionEnv()) {
    return '4009496695'
  }

  return '2926583809'
}

export const stripebaseUrl = `https://dashboard.stripe.com/${isProductionEnv() ? '' : 'test/'}`

export function getSendbirdApplicationId() {
  // see: https://dashboard.sendbird.com/{APP_ID}/settings/general
  // creds in 1pass
  if (isProductionEnv()) {
    return 'D1497904-61F7-4D7D-8683-94A136DAF452'
  }

  return '2766643B-BD7D-4B5B-826F-010482F72D42'
}
